import apisauce from "apisauce";
import IApiServices from "./ApiServicesInterfaces";
import { getLocalStorageItem, setLocalStorageItem } from "../utils/LocalStorage";
import { removeCookies, setCookies } from "../utils/Cookies";

const create = (
  baseURL = `${process.env.REACT_APP_SEKERON_USER_MANEGEMENT_URL}`
): IApiServices => {
  const api = apisauce.create({
    baseURL,
    headers: {
      "Cache-Control": "no-cache",
      "Content-Type": "application/json",
      Authorization: "",
    },
    timeout:
      // constants.tenThousandSeconds,
      1000000000,
  });

  api.addMonitor((response) => {
    if (response.status === 401) {
      localStorage.clear();
      removeCookies("userDetails", new Date());
      window.location.href = "/Login";
    }
  });

  // post apis
  const getAllPostsByUserId = async (reqBody: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const { data, pageNo, pageSize } = reqBody;
    const response = api.post(
      `${process.env.REACT_APP_SEKERON_POSTS_MANEGEMENT_URL}/post/pagination?pageNo=${pageNo}&pageSize=${pageSize}`,
      data
    );
    return response;
  };

  const getPostDetailsByPostId = async (reqBody: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const { userId, postId } = reqBody;
    const response = api.get(
      `${process.env.REACT_APP_SEKERON_POSTS_MANEGEMENT_URL}/user/${userId}/post/${postId}`,
      reqBody
    );
    return response;
  };

  const createPost = async (reqBody: any) => {
    const response = api.post(
      `${process.env.REACT_APP_SEKERON_POSTS_MANEGEMENT_URL}/post`,
      reqBody,
      {
        headers: {
          "Content-type": "multipart/form-data",
          Authorization: getLocalStorageItem("token"),
        },
      }
    );
    return response;
  };

  const deletePost = async (reqBody: any) => {
    const { postId } = reqBody;
    const response = api.delete(
      `${process.env.REACT_APP_SEKERON_POSTS_MANEGEMENT_URL}/post/${postId}`
    );
    return response;
  };

  const updatePost = async (reqBody: any) => {
    const response = api.put(
      `${process.env.REACT_APP_SEKERON_POSTS_MANEGEMENT_URL}/post/${reqBody.postId}`,
      reqBody.data
    );
    return response;
  };

  // profile
  const getProfileDetailsById = async (action: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response = api.get(`/user/${action.userId}`);
    return response;
  };

  const followUser = async (reqBody: any) => {
    const response = api.post(
      `${process.env.REACT_APP_SEKERON_CONSUMER_MANEGEMENT_URL}/follow/${reqBody.userId}/${reqBody.userIdToFollow}`
    );
    return response;
  };

  const getAllFollowing = async (reqBody: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const { pageNo, userId, pageSize } = reqBody;
    const response = await api.get(
      `${process.env.REACT_APP_SEKERON_CONSUMER_MANEGEMENT_URL}/${userId}/following?pageNo=${pageNo}&pageSize=${pageSize}`
    );

    return response;
  };

  const getAllShareUsers = async (reqBody: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const { pageNo, userId, pageSize } = reqBody;
    const response = await api.get(
      `${process.env.REACT_APP_SEKERON_CONSUMER_MANEGEMENT_URL}/${userId}/shareList?pageNo=${pageNo}&pageSize=${pageSize}`
    );

    return response;
  };

  const getAllMutuals = async (reqBody: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const { pageNo, userId, pageSize } = reqBody;
    const response = await api.get(
      `${process.env.REACT_APP_SEKERON_CONSUMER_MANEGEMENT_URL}/user/${userId}/mutual-followers?pageNo=${pageNo}&pageSize=${pageSize}`
    );

    return response;
  };


  const getAllFollowers = async (reqBody: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const { pageNo, userId, pageSize } = reqBody;
    const response = await api.get(
      `${process.env.REACT_APP_SEKERON_CONSUMER_MANEGEMENT_URL}/${userId}/followers?pageNo=${pageNo}&pageSize=${pageSize}`
    );
    return response;
  };

  const updateProfileDetails = async (data: any) => {
    const { userId, reqBody } = data;
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response = api.put(`/user/${userId}`, reqBody);
    return response;
  };

  // search following list
  const searchUserInFollowingList = async (reqBody: any) => {
    const { userName, userId } = reqBody;
    const response = api.get(
      `${process.env.REACT_APP_SEKERON_CONSUMER_MANEGEMENT_URL}/following/${userId}/search/${userName}`
    );
    return response;
  };

  // search followers list
  const searchUserInFollowersList = async (reqBody: any) => {
    const { userName, userId } = reqBody;
    const response = api.get(
      `${process.env.REACT_APP_SEKERON_CONSUMER_MANEGEMENT_URL}/follower/${userId}/search/${userName}`
    );
    return response;
  };

  // get save Post in Favourite
  const getAllSavedPost = async (reqBody: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const { pageNo, userId, pageSize = 20 } = reqBody;
    const response = await api.get(
      `${process.env.REACT_APP_SEKERON_POSTS_MANEGEMENT_URL}/user/${userId}/saved-post?pageNo=${pageNo}&pageSize=${pageSize}`
    );
    return response;
  };
  // save post to Favourite
  const saveOrUnsavePostToFavourite = async (reqBody: any) => {
    const { postId } = reqBody;
    const response = await api.post(
      `${process.env.REACT_APP_SEKERON_POSTS_MANEGEMENT_URL}/post/${postId}/save`
    );
    return response;
  };

  // get Like Post Api
  const getLikedPost = async (reqBody: any) => {
    const { pageNo, postId, pageSize } = reqBody;
    const response = await api.get(
      `${process.env.REACT_APP_SEKERON_POSTS_MANEGEMENT_URL}/like/post/${postId}?pageNo=${pageNo}&pageSize=${pageSize}`
    );
    return response;
  };

  // get Post View Api
  const getPostViews = async (postId: any) => {
    const response = await api.get(
      `${process.env.REACT_APP_SEKERON_POSTS_MANEGEMENT_URL}/post/${postId}/view`
    );
    return response;
  };

  // get Post View Api
  const getProjectViews = async (id: any) => {
    const response = await api.get(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/project/${id}/view`
    );
    return response;
  };

  // like post
  const likeOrUnlikePost = async (postId: any) => {
    const response = await api.post(
      `${process.env.REACT_APP_SEKERON_POSTS_MANEGEMENT_URL}/like/post/${postId}`
    );
    return response;
  };

  // get Search List In Like
  const searchUserInLikeLists = async (reqBody: any) => {
    const { postId, userName } = reqBody;
    const response = await api.get(
      `${process.env.REACT_APP_SEKERON_POSTS_MANEGEMENT_URL}/search/likes/post/${postId}/${userName}`
    );
    return response;
  };

  const uploadProffilePicturesToBackend = (reqBody: any) => {
    const { userId, data } = reqBody;
    return api.put(
      `${process.env.REACT_APP_SEKERON_USER_MANEGEMENT_URL}/user/${userId}/profile/image`,
      data,
      {
        headers: {
          "Content-type": "multipart/form-data",
          Authorization: getLocalStorageItem("token"),
        },
      }
    );
  };

  const deleteProfilePicture = async (reqBody: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const { userId, removingPicture } = reqBody;
    const response = await api.delete(
      `${process.env.REACT_APP_SEKERON_USER_MANEGEMENT_URL}/user/${userId}/profile/image/remove?imageToBeRemoved=${removingPicture}`
    );
    return response;
  };

  const logOutUser = async (reqBody: any) => {
    const { userId, logoutType, ipAddress, deviceId, channelType } = reqBody;
    setAuthorization(getLocalStorageItem("token"), ipAddress, deviceId, channelType);
    const response = await api.delete(
      `${process.env.REACT_APP_SEKERON_USER_MANEGEMENT_URL}/user/${userId}/sign-out?signOutType=${logoutType}`
    );
    return response;
  };

  // Login and profile creation

  const setAuthorization = (token: any, ipAddress: any, deviceId: any, channelType?: any) => {
    api.headers["Authorization"] = token ? token : "";
    api.headers["ipAddress"] = ipAddress ? ipAddress : "";
    api.headers["deviceId"] = deviceId ? deviceId : "";
    api.headers["channelType"] = (channelType || channelType === 0) ? channelType : '2';
  };

  const loginOtp = async (reqBody: any) => {
    // setAuthorization(getLocalStorageItem("token"), "", "");
    const response = await api.post(
      `${reqBody?.forPhone ? "/mobile/send-otp" : "/email/send-otp"}`,
      reqBody?.data
    );
    return response;
  };

  const loginOtpVerify = async (data: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response = await api.post(`/verify-otp`, data);
    return response;
  };

  const resendLoginOtp = async (reqBody: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response = await api.post(
      `${reqBody?.forPhone ? "/mobile/send-otp" : "/email/send-otp"}`,
      reqBody.data
    );
    return response;
  };

  const registerOtp = async (data: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response = await api.post(`/email/send-otp`, data);
    return response;
  };

  const registerOtpVerify = async (data: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response = await api.post(`/verify-otp`, data);
    return response;
  };

  // getAllUserLoginDetails 
  const getAllUserLoginDetails = async (userId: string) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response = await api.get(
      `${process.env.REACT_APP_SEKERON_USER_MANEGEMENT_URL}/user/${userId}/login-detail`
    );
    return response;
  };

  // update email Api
  const updateEmail = async (reqBody: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response = await api.post(
      `${process.env.REACT_APP_SEKERON_USER_MANEGEMENT_URL}/verify-update-otp`, reqBody
    );
    return response;
  };

  // update phone number Api
  const updatePhoneNumber = async (reqBody: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response = await api.put(
      `${process.env.REACT_APP_SEKERON_USER_MANEGEMENT_URL}/user/${reqBody?.userId}/update-number?phoneNumber=${reqBody?.phone}`
    );
    return response;
  };

  // update user FCM token Api
  const updateFCMToken = async (reqBody: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response = await api.put(
      `${process.env.REACT_APP_SEKERON_USER_MANEGEMENT_URL}/fcm-token/update`, reqBody
    );
    return response;
  };

  //delete-account
  const deleteAccount = async (reqBody: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response = await api.post(
      `${process.env.REACT_APP_SEKERON_USER_MANEGEMENT_URL}/${reqBody?.userId}/delete-account`, {}
    );
    return response;
  };

  //block user
  const blockUser = async (reqBody: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response = await api.post(
      `${process.env.REACT_APP_SEKERON_USER_MANEGEMENT_URL}/user/${reqBody?.userId}/block?status=${reqBody?.status}`, {}
    );
    return response;
  };

  const createProfile = async (data: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response = await api.post(`/user/register`, data);
    return response;
  };

  const createProfilePhoneNumberOtpVerify = async (data: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response = await api.post(`/verify-otp`, data);
    return response;
  };

  const createProfileResendPhoneNumberOtp = async (data: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response = await api.post(`/user/register`, data);
    return response;
  };

  const checkUserNameAvaibility = async (data: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response = await api.get(`/verify/${data.profileName?.toLowerCase()?.trim()}`);
    return response;
  };

  const createUserName = async (data: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");

    // Type assertion for the response
    const response = await api.post(`/user-details`, data) as { data: { data: { accessToken: string, [key: string]: any } } };

    console.log(response, "response");
    setLocalStorageItem("token", response.data.data.accessToken);
    // setLocalStorageItem("userDetails", JSON.stringify(response.data.data));
    setCookies("userDetails", JSON.stringify(response.data.data));

    window.location.reload();
    return response;
  };


  const registerWithOAuth = async (reqBody: any) => {
    setAuthorization("", "", "");
    const response = api.post(`/oAuth`, reqBody);
    return response;
  };

  //facebook login api
  const registerFacebookWithOAuth = async (reqBody: any) => {
    setAuthorization("", "", "");
    const response = api.post(`/facebook/oAuth`, reqBody);
    return response;
  };

  // skills
  const getAllSkills = async (reqBody: any) => {
    let response;
    if (reqBody?.name) {
      response = await api.get(`/skill?name=${reqBody?.name}`);
    } else {
      response = await api.get(`/skill`);
    }
    return response;
  };

  const AddUserSkills = async (data) => {
    const response = await api.post(`/add-user-skills`, data);
    return response;
  }

  // categories
  const getAllCategories = async () => {
    const response = await api.get(`/category/getall-category`);
    return response;
  };

  const createSkill = async (data: any) => {
    const response = await api.post(`skill`, data);
    return response;
  };

  const getAllRoles = async () => {
    setAuthorization("", "", "");
    const response = api.get(`/role/getAll`);
    return response;
  };

  // comments Api

  const getAllCommentsByPostId = async (data: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const { pageNo, pageSize, postId } = data;
    const response = await api.get(
      `${process.env.REACT_APP_SEKERON_POSTS_MANEGEMENT_URL}/comment/post/${postId}?pageNo=${pageNo}&pageSize=${pageSize}`
    );
    return response;
  };

  const getAllCommentRepliesByCommentId = async (data: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const { commentId, pageNo, pageSize } = data;
    const response = await api.get(
      `${process.env.REACT_APP_SEKERON_POSTS_MANEGEMENT_URL}/comment/${commentId}/reply?pageNo=${pageNo}&pageSize=${pageSize}`
    );
    return response;
  };

  const addComments = async (reqBody: any) => {
    const response = await api.post(
      `${process.env.REACT_APP_SEKERON_POSTS_MANEGEMENT_URL}/comment`,
      reqBody
    );
    return response;
  };

  const addReply = async (reqBody: any) => {
    const { commentId, reply } = reqBody;
    const response = await api.post(
      `${process.env.REACT_APP_SEKERON_POSTS_MANEGEMENT_URL}/comment/${commentId}/reply`,
      reply,
      reqBody
    );
    return response;
  };

  const deleteComment = async (commentId: any) => {
    const response = await api.delete(
      `${process.env.REACT_APP_SEKERON_POSTS_MANEGEMENT_URL}/comment/${commentId}`
    );
    return response;
  };

  const deleteReply = async (commentId: any) => {
    const response = await api.delete(
      `${process.env.REACT_APP_SEKERON_POSTS_MANEGEMENT_URL}/comment/reply/${commentId}`
    );
    return response;
  };

  // get Home Post

  const getHomePost = async (reqBody: any) => {
    const { pageNo, pageSize } = reqBody;
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response = await api.get(
      `${process.env.REACT_APP_SEKERON_POSTS_MANEGEMENT_URL}/post/home?pageNo=${pageNo}&pageSize=${pageSize}`
    );
    return response;
  };

  // profile upload profile and cover pictures to backend

  const refreshAuthToken = async (reqBody: any) => {
    const { userId, deviceId } = reqBody;
    setAuthorization("", "", deviceId);
    const response = await api.put(
      `${process.env.REACT_APP_SEKERON_USER_MANEGEMENT_URL}/user/${userId}/refresh`
    );
    return response;
  };

  const fetchIpAddress = async (reqBody: any) => {
    const response = await api.get(`https://geolocation-db.com/json/`);
    return response;
  };

  // explore
  const searchProfilesInExplore = async (querries: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const { pageNo, pageSize, name } = querries;
    const response: any = await api.get(
      `/search-user?pageNo=${pageNo}&pageSize=${pageSize}&name=${name}`
    );
    return response;
  };

  const serachPostsInExplore = async (querries: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const { pageNo, pageSize, name } = querries;
    const response: any = await api.get(
      `${process.env.REACT_APP_SEKERON_POSTS_MANEGEMENT_URL}/post/explore?pageNo=${pageNo}&pageSize=${pageSize}&name=${name}`
    );
    return response;
  };

  const serachProjectsInExplore = async (querries: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const { pageNo, pageSize, name } = querries;
    const response: any = await api.get(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/project/explore?pageNo=${pageNo}&pageSize=${pageSize}&name=${name}`
    );
    return response;
  };

  const serachAllProjectsInExplore = async (querries: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const { pageNo, pageSize, name } = querries;
    const response: any = await api.get(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/project/explore/all?pageNo=${pageNo}&pageSize=${pageSize}&name=${name}`
    );
    return response;
  };

  const serachArtistInExplore = async (querries: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const { pageNo, pageSize, name } = querries;
    const response: any = await api.get(
      `${process.env.REACT_APP_SEKERON_USER_MANEGEMENT_URL}/explore-artists?pageNo=${pageNo}&pageSize=${pageSize}&name=${name}`
    );
    return response;
  };

  const projectFilterInExplore = async (data: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response: any = await api.post(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/filter/project`, data
    );
    return response;
  };

  const postFilterInExplore = async (data: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response: any = await api.post(
      `${process.env.REACT_APP_SEKERON_POSTS_MANEGEMENT_URL}/filter/post`, data
    );
    return response;
  };

  const userFilterInExplore = async (data: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response: any = await api.post(
      `${process.env.REACT_APP_SEKERON_USER_MANEGEMENT_URL}/filter/artists`, data
    );
    return response;
  };

  // Create project
  const getUsersListBasedOnSkillId = async (reqBody: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    let response;
    if (reqBody?.artistName) {
      response = api.get(
        `${process.env.REACT_APP_SEKERON_USER_MANEGEMENT_URL}/user/skill/${reqBody.skillId}?pageSize=10&userId=${reqBody?.userId}&pageNo=1&name=${reqBody?.artistName}`
      );
    } else {
      response = api.get(
        `${process.env.REACT_APP_SEKERON_USER_MANEGEMENT_URL}/user/skill/${reqBody.skillId}?pageSize=25&pageNo=1&userId=${reqBody?.userId}`
      );
    }
    return response;
  };

  const createProject = async (reqBody: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response = await api.post(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/project`,
      reqBody
    );
    return response;
  };

  const updateProject = async (data: any) => {
    const { projectId, reqBody } = data;
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response = await api.put(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/project/${projectId}/edit-project`,
      reqBody
    );
    return response;
  };

  const saveProject = async (data: any) => {
    const { projectId } = data;
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response = await api.post(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/project/${projectId}/save`
    );
    return response;
  };

  const uploadProjectMedia = async (reqBody: any) => {
    const response = await api.post(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/project-media`,
      reqBody,
      {
        headers: {
          "Content-type": "multipart/form-data",
          Authorization: getLocalStorageItem("token"),
        },
      }
    );
    return response;
  };

  const getAllMyProjects = async (reqBody: any) => {
    const { userId, pageNo, pageSize } = reqBody;
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response = await api.get(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/user/${userId}/project?pageSize=${pageSize}&pageNo=${pageNo}`
    );
    return response;
  };

  const getAllMyCollaboratedProjects = async (reqBody: any) => {
    const { userId, pageSize, pageNo } = reqBody;
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response = await api.get(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/user/${userId}/collaborated-project?pageSize=${pageSize}&pageNo=${pageNo}`
    );
    return response;
  };

  const getAllSavedProjects = async (reqBody: any) => {
    const { pageNo, userId, pageSize } = reqBody;
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response = await api.get(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/user/${userId}/saved-project?pageNo=${pageNo}&pageSize=${pageSize}&startDate=&endDate=`
    );
    return response;
  };

  //dashboard apis
  const getDashboardData = async (reqBody: any) => {
    const { userId } = reqBody;
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response = await api.get(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/user/${userId}/dashboard`
    );
    return response;
  };

  const getAllMyProjectsBasedOnStatus = async (reqBody: any) => {
    const { userId, pageSize, pageNo, projectStatus } = reqBody;
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response = await api.get(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/user/${userId}/dashboard/my-project?pageSize=${pageSize}&pageNo=${pageNo}&projectStatus=${projectStatus}`
    );
    return response;
  };

  const getAllMyCollaboratedProjectsBasedOnStatus = async (reqBody: any) => {
    const { userId, pageSize, pageNo, projectStatus } = reqBody;
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response = await api.get(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/user/${userId}/dashboard/collaborated-project?pageSize=${pageSize}&pageNo=${pageNo}&projectStatus=${projectStatus}`
    );
    return response;
  };

  const getProjectDetailsById = async (reqBody: any) => {
    const { projectId } = reqBody;
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response = await api.get(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/project/${projectId}`
    );
    return response;
  };

  const getAllArtistsOfProjectByInviteStatus = async (reqBody: any) => {
    const { projectId, pageNo, pageSize, status } = reqBody;
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response = await api.get(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/project/${projectId}/get-artists?pageNo=${pageNo}&parameter=${status}&pageSize=${pageSize}`
    );
    return response;
  };

  const removeCollaboratorById = async (reqBody: any) => {
    const { projectId, artistId, skillId } = reqBody;
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response = await api.delete(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/project/${projectId}/remove-collaborator/${skillId}/${artistId}`
    );
    return response;
  };

  const getCollaboratorNegotiationDetails = async (reqBody: any) => {
    const { projectId, artistId, skillId } = reqBody;
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response = await api.get(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/project/${projectId}/skill/${skillId}/artist/${artistId}`
    );
    return response;
  };

  const applyProject = async (data: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const { projectId, skillId } = data;
    const response = await api.post(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/project/${projectId}/skill/${skillId}/apply`,
      data.reqBody
    );
    return response;
  };

  const acceptInvitation = async (data: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const { projectId, skillId } = data;
    const response = await api.post(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/project/${projectId}/skill/${skillId}/accept-term`,
      data.reqBody
    );
    return response;
  };

  const acceptOrDeclineCollaborationRequest = async (data: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const { projectId, skillId, artistId, requestType } = data;
    const response = await api.post(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/project/${projectId}/artist/${artistId}/skill/${skillId}/request/handle?status=${requestType}`,
      data.reqBody
    );
    return response;
  };

  const rejectProjectInvite = async (data: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const { projectId, skillId, artistId } = data;
    const response = await api.put(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/project/${projectId}/artist/${artistId}/skill/${skillId}/invite/handle`
    );
    return response;
  };

  const inviteCollaborator = async (data: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    // api.headers["Content-Type"] = "application/json";
    const { projectId, reqBody } = data;
    const response = await api.put(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/project/${projectId}`,
      reqBody
    );
    return response;
  };

  const getAllInvitedCollaborators = async (data: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const { projectId, skillId } = data;
    const response = await api.get(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/project/${projectId}/skill/${skillId}/get-invited-artists`
    );
    return response;
  };

  const exitProject = async (data: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const { projectId } = data;
    const response = await api.delete(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/project/${projectId}/exit-project`
    );
    return response;
  };

  const reNegotiation = async (data: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const { projectId, artistId, skillId, reqBody } = data;
    const response = await api.put(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/project/${projectId}/skill/${skillId}/artist/${artistId}/re-negotiate`,
      reqBody
    );
    return response;
  };

  const endProject = async (data: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const { projectId, reqBody } = data;
    const response = await api.put(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/project/${projectId}/end-project`,
      reqBody
    );
    return response;
  };

  const rateAllProjectMembers = async (data: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const { projectId, reqBody } = data;
    const response = await api.put(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/project/${projectId}/project-rating`,
      reqBody
    );
    return response;
  }

  const fetchProjectContract = async (projectId: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response = await api.get(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/project/${projectId}/fetchContract`,
    );
    return response;
  };

  const getAllCollaborators = async (data: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const { projectId, pageSize, pageNo, userName, userId } = data;
    let response;
    if (userName) {
      response = await api.get(
        `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/project/${projectId}/collaborated-artists?pageNo=${pageNo}&pageSize=${pageSize}&name=${userName}&userId=${userId}`
      );
    } else {
      response = await api.get(
        `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/project/${projectId}/collaborated-artists`
      );
    }
    return response;
  };

  const deleteProject = async (data: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const { projectId } = data;
    const response = await api.delete(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/project/${projectId}`
    );
    return response;
  };

  const getProjectMedias = async (data: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const { projectId, pageNo, pageSize, mediaType } = data;
    const response = await api.get(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/project/${projectId}/project-media?pageNo=${pageNo}&pageSize=${pageSize}&mediaType=${mediaType}`
    );
    return response;
  };

  // tasks
  const createProjectTask = async (data: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const { projectId, reqBody } = data;
    const response = await api.post(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/project/${projectId}/create-task`,
      reqBody
    );
    return response;
  };

  const getProjectTasks = async (data: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const { projectId, pageSize, pageNo } = data;
    const response = await api.get(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/project/${projectId}/get-task`
    );
    return response;
  };

  const getAllProjectTasks = async (data: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const { userId, pageSize, pageNo } = data;
    const response = await api.get(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/project/user/${userId}/get-artist-task
`
    );
    return response;
  };

  const getAllAssigneesByTaskId = async (data: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const { taskId, pageSize, pageNo } = data;
    const response = await api.get(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/project/task/${taskId}/get-assignee?pageNo=${pageNo}&pageSize=${pageSize}`
    );
    return response;
  };

  const getAllUnassignedArtistsByTaskId = async (data: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const { taskId, pageSize, pageNo } = data;
    const response = await api.get(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/project/task/${taskId}/un-assigned-collaborator?pageNo=${pageNo}&pageSize=${pageSize}`
    );
    return response;
  };

  const removeAssignedArtists = async (data: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const { projectId, artistId, taskId } = data;
    const response = await api.delete(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/project/${projectId}/task/${taskId}/artist/${artistId}/remove-assignee`
    );
    return response;
  };

  const updateTaskById = async (data: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const { projectId, taskId, reqBody } = data;
    const response = await api.put(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/project/${projectId}/task/${taskId}`,
      reqBody
    );
    return response;
  };

  const deleteTask = async (data: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const { projectId, taskId } = data;
    const response = await api.delete(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/project/${projectId}/task/${taskId}`
    );
    return response;
  };

  const getTaskDetailsById = async (data: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const { taskId, projectId } = data;
    const response = await api.get(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/project/${projectId}/task/${taskId}`
    );
    return response;
  };

  const selfTaskAssignment = async (data: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const { projectId, reqBody } = data;
    const response = await api.post(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/project/${projectId}/create-self-task`,
      reqBody
    );
    return response;
  };

  const getAllProjectMembers = async (projectId: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response = await api.get(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/project/${projectId}/project-members`,
    );
    return response;
  };

  //project meetings
  const getAllMeetings = async (data: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response = await api.get(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/project-calender/getAll`
    );
    return response;
  };

  const getAllMeetingsById = async (projectId: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response = await api.get(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/project-calender/meeting/${projectId}`
    );
    return response;
  };

  const createMeeting = async (data: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response = await api.post(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/project-calender/create-meeting`, data
    );
    return response;
  };

  const updateMeeting = async (data: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response = await api.put(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/project-calender/${data?.projectId}`, data
    );
    return response;
  };

  const deleteMeeting = async (projectId: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response = await api.delete(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/project-calender/${projectId}`
    );
    return response;
  };

  //report post api
  const reportPost = async (data: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response = await api.post(
      `${process.env.REACT_APP_SEKERON_POSTS_MANEGEMENT_URL}/post/${data?.id}/report`, data
    );
    return response;
  };

  //report comment api
  const reportComment = async (data: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response = await api.post(
      `${process.env.REACT_APP_SEKERON_POSTS_MANEGEMENT_URL}/comment/${data?.id}/report`, data
    );
    return response;
  };

  //report comment-reply api
  const reportReply = async (data: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response = await api.post(
      `${process.env.REACT_APP_SEKERON_POSTS_MANEGEMENT_URL}/comment/reply/${data?.id}/report`, data
    );
    return response;
  };

  //report project api
  const reportProject = async (data: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response = await api.post(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/project/${data?.id}/report`, data?.data
    );
    return response;
  };

  //report user api
  const reportUser = async (data: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response = await api.post(
      `${process.env.REACT_APP_SEKERON_USER_MANEGEMENT_URL}/user/report`, data
    );
    return response;
  };

  //report problem api
  const reportProblem = async (data: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response = await api.post(
      `${process.env.REACT_APP_SEKERON_USER_MANEGEMENT_URL}/generic/report`, data
    );
    return response;
  };


  // chat - api
  const getAllCollaboratorsByProjectId = async (projectId: any) => {
    const response = await api.get(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/project/${projectId}/collaborator-ids`
    );
    return response;
  };

  const createProjectGroupChat = async (data: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response = await api.post(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/project/${data?.projectId}/group`, data
    );
    return response;
  };

  const getProjectGroupChatDetails = async (data: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response = await api.get(
      `${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/project/${data?.projectId}/group`);
    return response;
  };

  //notifications
  const getAllUserNotifications = async (data: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const { userId, pageNo, pageSize } = data;
    const response = await api.get(
      `${process.env.REACT_APP_SEKERON_USER_MANEGEMENT_URL}/notification/user/${userId}?pageSize=${pageSize}&pageNo=${pageNo}&notificationType=3`
    );
    return response;
  };

  const updateNotification = async (id: any) => {
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response = await api.put(
      `${process.env.REACT_APP_SEKERON_USER_MANEGEMENT_URL}/notification/view-status?viewStatus=true&notificationIds=${id}`
    );
    return response;
  };

  // disconnect and destroy session id
  const disconnectAndDestroySessionId = async (sessionId: string) => {
    const response = await api.delete(
      `${process.env.REACT_APP_SEKERON_USER_MANEGEMENT_URL}/session/${sessionId}/dis-connect`
    );
    return response;
  };

  const generateSessionId = async (userId: string, deviceId: any) => {
    setAuthorization(getLocalStorageItem(""), "", deviceId);
    const response = await api.put(
      `${process.env.REACT_APP_SEKERON_USER_MANEGEMENT_URL}/user/${userId}/connect`
    );
    return response;
  };

  //events
  const registerUserInEvent = async (reqBody: any) => {
    const { eventId, userId, data, amount, promocode } = reqBody;
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response = await api.post(
      `${process.env.REACT_APP_SEKERON_USER_MANEGEMENT_URL}/event/participants/${eventId}?userId=${userId}&amount=${amount}&promocode=${promocode}`, data
    );
    return response;
  }

  const createOrderRazorpay = async (reqBody: any) => {
    const { amount, receiptId, eventId, promocode } = reqBody;
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response = await api.post(
      `${process.env.REACT_APP_SEKERON_USER_MANEGEMENT_URL}/payment/create-order?amount=${amount}&currency=INR&receiptId=${receiptId}&eventId=${eventId}&promocode=${promocode}`, {}
    );
    return response;
  }

  const verifyPromoCode = async (reqBody: any) => {
    const { promocode, eventId } = reqBody;
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response = await api.get(
      `${process.env.REACT_APP_SEKERON_USER_MANEGEMENT_URL}/event/verify-promocode?eventId=${eventId}&promocode=${promocode}`);
    return response;
  }

  const getEventRefund = async (reqBody: any) => {
    const { userId, eventId, refundReason } = reqBody;
    setAuthorization(getLocalStorageItem("token"), "", "");
    const response = await api.get(
      `${process.env.REACT_APP_SEKERON_USER_MANEGEMENT_URL}/payment/refund-payment?userId=${userId}&eventId=${eventId}&refundReason=${refundReason}`);
    return response;
  }

  return {
    // Post
    getPostDetailsByPostId,
    getAllPostsByUserId,
    deletePost,
    updatePost,
    createPost,

    // Profile
    getProfileDetailsById,
    followUser,
    getAllFollowing,
    getAllShareUsers,
    getAllMutuals,
    getAllFollowers,
    updateProfileDetails,
    searchUserInFollowingList,
    searchUserInFollowersList,
    getAllSavedPost,
    saveOrUnsavePostToFavourite,
    likeOrUnlikePost,
    getLikedPost,
    getPostViews,
    getProjectViews,
    uploadProffilePicturesToBackend,
    deleteProfilePicture,
    searchUserInLikeLists,

    // login and profile creation
    loginOtp,
    loginOtpVerify,
    registerOtp,
    registerOtpVerify,
    createProfile,
    createProfilePhoneNumberOtpVerify,
    createProfileResendPhoneNumberOtp,
    checkUserNameAvaibility,
    resendLoginOtp,
    getAllSkills,
    AddUserSkills,
    createSkill,
    getAllCategories,
    createUserName,
    getAllRoles,
    setAuthorization,
    refreshAuthToken,
    fetchIpAddress,
    logOutUser,
    registerWithOAuth,
    registerFacebookWithOAuth,
    getAllUserLoginDetails,
    updateEmail,
    updatePhoneNumber,
    updateFCMToken,
    deleteAccount,
    blockUser,

    // home
    getAllCommentsByPostId,
    getAllCommentRepliesByCommentId,
    addComments,
    addReply,
    deleteComment,
    deleteReply,
    getHomePost,

    // Explore
    searchProfilesInExplore,
    serachPostsInExplore,
    serachProjectsInExplore,
    serachAllProjectsInExplore,
    serachArtistInExplore,
    projectFilterInExplore,
    postFilterInExplore,
    userFilterInExplore,

    // Create project apis
    getUsersListBasedOnSkillId,
    createProject,
    uploadProjectMedia,
    getAllMyProjects,
    getAllMyCollaboratedProjects,
    updateProject,
    saveProject,
    getAllSavedProjects,

    //dashboard apis
    getDashboardData,
    getProjectDetailsById,
    getAllMyProjectsBasedOnStatus,
    getAllMyCollaboratedProjectsBasedOnStatus,
    getAllArtistsOfProjectByInviteStatus,
    removeCollaboratorById,
    getCollaboratorNegotiationDetails,
    applyProject,
    acceptOrDeclineCollaborationRequest,
    rejectProjectInvite,
    inviteCollaborator,
    getAllInvitedCollaborators,
    exitProject,
    reNegotiation,
    endProject,
    rateAllProjectMembers,
    fetchProjectContract,
    getAllCollaborators,
    acceptInvitation,
    deleteProject,
    getProjectMedias,

    // Tasks
    getProjectTasks,
    getAllProjectTasks,
    createProjectTask,
    getAllAssigneesByTaskId,
    getAllUnassignedArtistsByTaskId,
    removeAssignedArtists,
    updateTaskById,
    deleteTask,
    getTaskDetailsById,
    selfTaskAssignment,
    getAllProjectMembers,

    // Meetings
    getAllMeetings,
    getAllMeetingsById,
    updateMeeting,
    createMeeting,
    deleteMeeting,

    //Report 
    reportPost,
    reportComment,
    reportReply,
    reportProject,
    reportUser,
    reportProblem,

    // chat
    createProjectGroupChat,
    getProjectGroupChatDetails,
    getAllCollaboratorsByProjectId,

    //notifications
    getAllUserNotifications,
    updateNotification,

    // disconnect and destroy session id
    disconnectAndDestroySessionId,
    generateSessionId,

    //event
    registerUserInEvent,
    createOrderRazorpay,
    verifyPromoCode,
    getEventRefund
  };
};

export default {
  create,
};
